// extracted by mini-css-extract-plugin
module.exports = {"container":"userData_container__2YRX5","name":"userData_name__3-NLM","other":"userData_other__19bZP"};